export function applyLancamentoBoot({ prev = {}, parametro, dados, pessoaId }) {
    const parceiro = parametro?.pessoaPadrao;

    return {
        ...prev,

        valorOriginal: null,
        situacaoId: prev?.situacaoId ?? 1,
        tipo: prev?.tipo ?? 'Receber',

        contaId: prev?.contaId ?? parametro?.contaId,
        prazoId: prev?.prazoId ?? parametro?.transferenciaPrazo,
        centroCustoId: prev?.centroCustoId ?? parametro?.centroCustoPDV,

        dataLancamento: prev?.dataLancamento ?? dados?.data,
        dataVencimento: prev?.dataVencimento ?? dados?.data,

        Parceiro: parceiro,

        // 🔑 sincroniza parceiro com id
        pessoaId: prev?.pessoaId ?? parceiro?.id ?? pessoaId,
    };
}
